import { createReducer, on } from '@ngrx/store';
import { widgetToggleAutoPublish, widgetUpdate } from './widget_actions';
import { initialWidgetState } from './widget_state';

export const widgetReducer = createReducer(
  initialWidgetState,
  on(widgetToggleAutoPublish, (state, action) => ({...state, autoPublish: action.autoPublish})),
  on(widgetUpdate, (state, action) => ({...state, ...action.payload})),
);
